<template>
  <div class="content_all2" id="join_us">
    <div class="content_box">

      <div class="list_box w700">
        <div class="y_ititle2">國立臺灣大學校總區戶外球場網路抽籤申請書</div>

        <div class="jubox">
          <table>
            <tr>
              <th>申請年度</th>
              <td>
                <Select style="width:200px" v-model="recordToEditApply.rocYear">
                  <Option v-for="item in yearList" :value="item" :key="item">{{ item }}</Option>
                </Select>
              </td>
            </tr>
            <tr>
              <th>申請系所</th>
              <td>
              <Input v-model="recordToEdit.unitName"></Input>
              <div class="mt5">
              <input name="" type="radio"  value="1" v-model="recordToEdit.unitType">大學部
              <span class="ml15"><input name="" type="radio"  value="2" v-model="recordToEdit.unitType">研究所</span>
              <span class="ml15"><input name="" type="radio"  value="3" v-model="recordToEdit.unitType"> 社團</span>    </div>    </td>
            </tr>
            <tr>
              <th>申請類別</th>
              <td>
              <input name="" type="radio"  value="1" v-model="recordToEdit.teamType"> 男子籃球隊
              <span class="ml15"><input name="" type="radio" value="2" v-model="recordToEdit.teamType"> 男子排球隊</span>
              <span class="ml15"><input name="" type="radio" value="3" v-model="recordToEdit.teamType"> 男子足球隊</span>
              <span class="ml15"><input name="" type="radio" value="4" v-model="recordToEdit.teamType"> 棒球隊</span>

              <div class="mt5">
              <input name="" type="radio" value="5" v-model="recordToEdit.teamType"> 女子籃球隊
              <span class="ml15"><input name="" type="radio" value="6" v-model="recordToEdit.teamType"> 女子排球隊</span>
              <span class="ml15"><input name="" type="radio" value="7" v-model="recordToEdit.teamType"> 女子足球隊</span>
              <span class="ml15"><input name="" type="radio" value="8" v-model="recordToEdit.teamType"> 壘球隊</span>    </div>
              
              <div class="mt5">
              <input name="" type="radio" value="9" v-model="recordToEdit.teamType"> 其他
              <span class="ml5"><input name="" type="text" class="input_style3" v-model="recordToEdit.teamTypeOther"></span>    </div>
              </td>
            </tr>
            <tr>
              <th>申請場館</th>
              <td>
                <div class="mt5">
                  <input name="" type="radio" value="1" v-model="recordToEdit.buildingGroup"> 體育館
                  <span class="ml15"><input name="" type="radio" value="2" v-model="recordToEdit.buildingGroup"> 綜合體育館</span>
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="2"><div class="y_ititle2">負責人 / 聯絡人</div></td>
              </tr>
            <tr>
              <th>姓名</th>
              <td><Input v-model="recordToEdit.contactName"></Input></td>
            </tr>
            <tr>
              <th>學號</th>
              <td><Input v-model="recordToEdit.contactSchoolId"></Input></td>
            </tr>
            <tr>
              <th>電話</th>
              <td><Input v-model="recordToEdit.contactMobile"></Input></td>
            </tr>
            <tr>
              <th>Email</th>
              <td><Input v-model="recordToEdit.contactEmail"></Input></td>
            </tr>
            <tr>
              <td colspan="2" class="pt15 pb15"><div class="psbox">注意事項</div></td>
              </tr>
            <tr>
              <td colspan="2" class="text-center tx14"><input name="" type="checkbox" v-model="agree" > 我已閱讀相關注意事項</td>
              </tr>    
          </table>
        </div>

        <div class="tomi mt15">
          <button type="submit" class="btn_m" @click="saveData">送出申請</button>
          <button type="submit" class="btn_n" @click="goBack">回上一頁</button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { API, Message } from '@/assets/project_setting/config';
import { GetErrorHandler, PostErrorHandler, ShowMessage } from '@/assets/library/axiosErrorHandler';


export default {
  name: 'join_us',
  data() {
    return {
      yearList: [],
      recordToEdit: {
        unitName: '',
        unitType: '',
        teamType: '',
        teamTypeOther: '',
        contactName: '',
        contactSchoolId: '',
        contactMobile: '',
        contactEmail: '',
        rentLimit: '',
        account: '',
        password: '',
        buildingGroup : '0',
      },
      recordToEditApply: {
        yearUserId: '',
        rocYear: '',
        status: '',
        passDate: '',
        validDate: '',
        applyType: '',
      },
      agree: false,
    };
  },
  created() {
    axios.defaults.headers.common['X-Jesda-Api-Key'] = sessionStorage.getItem("TokenID");
    let now = new Date()
    let yy = now.getFullYear() - 1910;
    for (var i = yy; i > yy-3;  i--) {
      this.yearList.push(i)
    }
  },
  methods: {
    saveData() {
      try {
        this.checkField();
      } catch (error) {
        alert(error.message);
        return;
      }
      let form = new FormData();

      form.append('unitName', this.recordToEdit.unitName);
      form.append('unitType', this.recordToEdit.unitType);
      form.append('teamType', this.recordToEdit.teamType);
      form.append('teamTypeOther', this.recordToEdit.teamTypeOther);
      form.append('contactName', this.recordToEdit.contactName);
      form.append('contactSchoolId', this.recordToEdit.contactSchoolId);
      form.append('contactMobile', this.recordToEdit.contactMobile);
      form.append('contactEmail', this.recordToEdit.contactEmail);
      form.append('buildingGroup', this.recordToEdit.buildingGroup);

      this.$Message.loading({ content: '儲存中...', duration: 0 });

      axios.post(API.rent_yearuser, form, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(response => {
          this.$Message.destroy();
          ShowMessage(Message.SaveSuccessfully[sessionStorage.locale]);
          this.saveApplyData(response.data.id);
        })
        .catch(error => {
          this.$Message.destroy();
          PostErrorHandler.bind(this)(error, 'rent_yearuser');
        });
    },
    checkField() {
      this.checkApplyField();
      if (!this.recordToEdit.unitName)
        throw new Error('請填寫申請系所');
      if (!this.recordToEdit.unitType)
        throw new Error('請選擇申請系所類型');
      if (!this.recordToEdit.teamType)
        throw new Error('請選擇申請類別');
      if (this.recordToEdit.teamType == 9 && !this.recordToEdit.teamTypeOther)
        throw new Error('請填寫申請類別');

      if (!this.recordToEdit.contactName)
        throw new Error('請填寫聯絡人姓名');
      if (!this.recordToEdit.contactSchoolId)
        throw new Error('請填寫聯絡人學號');
      if (!this.recordToEdit.contactMobile)
        throw new Error('請填寫聯絡人電話');
      if (!this.recordToEdit.contactEmail)
        throw new Error('請填寫聯絡人Email');
      if (!this.agree)
        throw new Error('請先閱讀相關注意事項');
      this.checkMobile();
      this.checkEmail();
    },
    checkMobile() {
      let regExp = /^09[0-9]{8}$/;
      if (this.recordToEdit.contactMobile && !this.recordToEdit.contactMobile.match(regExp)) {
        throw new Error('電話欄位無效');
      }
    },
    checkEmail() {
      let regExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (this.recordToEdit.contactEmail && !this.recordToEdit.contactEmail.match(regExp)) {
        throw new Error('電子信箱欄位無效');
      }
    },
    saveApplyData(yearUserId) {
      try {
        this.checkApplyField();
      } catch (error) {
        alert(error.message);
        return;
      }
      let form = new FormData();

      form.append('yearUserId', yearUserId);
      form.append('rocYear', this.recordToEditApply.rocYear);
      form.append('status', '0');
      form.append('applyType', 1);

      this.$Message.loading({ content: '儲存中...', duration: 0 });

      axios.post(API.rent_yearuserapply, form, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(response => {
          this.$Message.destroy();
          ShowMessage(Message.SaveSuccessfully[sessionStorage.locale]);
          this.$router.push({name: 'home'});
        })
        .catch(error => {
          this.$Message.destroy();
          PostErrorHandler.bind(this)(error, 'rent_yearuserapply');
        });
    },
    checkApplyField() {
      if (!this.recordToEditApply.rocYear)
        throw new Error('請選擇學年度');
    },

    goBack() {
      // window.window.history.go(-1)
      window.history.go(-1)
      
    }
  },
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// JoinUs.vue?2f809f71